import { Row as ARow } from 'antd';
import styled from 'styled-components';

export const SRow = styled(ARow)`
  margin-top: 0;
  margin-bottom: 0;
`;
